import configurator from 'bookingbug-configurator-js';
import { BaseAnalyticsProvider } from './BaseAnalyticsProvider';

/* eslint-disable */
export class GoogleAnalyticsProvider extends BaseAnalyticsProvider {
  constructor(config, providerId, providerName) {
    super(config, providerId, providerName);
    window.gtag && window.gtag('config', providerId, { providerName });
  }

  /**
   * @description
   * Method for sending an event object which contains: category, action and label.
   * the category is required and defines the group of inputs that we want to track
   * the action is required and defines the type of event or interaction we want to track
   * the label is optional and provides additional information for the events that we want to track
  */
  eventTrack(...args) {
    this.providerName === 'external' ? this.externalTrack(...args) : this.internalTrack(...args);
  }

  internalTrack(event, trackLabelInfo, trackCategoryInfo, trackActionInfo) {
    const newEventLabel = this.generateTrackingString(event.label, trackLabelInfo);
    const newCategoryLabel = this.generateTrackingString(event.category, trackCategoryInfo);
    const newActionLabel = this.generateTrackingString(event.action, trackActionInfo);

    window.gtag && window.gtag('event', newActionLabel, {
        newCategoryLabel,
        newEventLabel,
      });
  }

  externalTrack(event) {
    window.gtag && window.gtag(`${this.providerName}.send`,
      'event', event.category, event.action, event.label);
  }

  pageView(page) {
    const { client, product } = configurator;

    if (this.config.aliases && this.config.aliases.useAlias) {
      page = this.config.aliases.states[page] || page;
    }

    const pageString = this.providerName === 'external' ? page : `${page} | ${client} | Product ${product}`;

    window.gtag && window.gtag('event', 'pageview', {
      title: pageString,
      page,
  });
  }

  /*
     * Override this method to avoid error throwing.
     *
     * Keep in mind this is not needed because GA is the default engine
     */
  static bootstrap(config) {
    return true;
  }

  static get name() {
    return 'GoogleAnalytics';
  }
}
